import React from "react";
import { useTranslation } from "react-i18next";
import {
  ShoppingCart,
  Pill,
  Shirt,
  Smartphone,
  UtensilsCrossed,
  Croissant,
  Scissors,
  Package,
  Coffee,
  Calendar,
 Send,
 Smile,
 Truck
} from "lucide-react";

const Industries = () => {
  const { t } = useTranslation();

  const industries = [
    {
      icon: <ShoppingCart size={28} />,
      title: t("Supermarkets"),
      desc: t("Multi-aisle, fast-scan"),
      link: "/industries/supermarket",
    },
    {
      icon: <Calendar size={28} />,
      title: t("Pharmacies"),
      desc: t("Batch & expiry tracking"),
      link: "/industries/pharmacy",
    },
    {
      icon: <Shirt size={28} />,
      title: t("Fashion & Apparel"),
      desc: t("Size, colour, variants"),
      link: "/industries/fashion",
    },
    {
      icon: <Smartphone size={28} />,
      title: t("Electronics"),
      desc: t("Serial numbers & warranty"),
      link: "/industries/electronics",
    },
    {
      icon: <Coffee size={28} />,
      title: t("Confectioneries"),
      desc: t("Sweets, chocolates, gifting"),
      link: "/industries/restaurant",
    },
    {
      icon: <Send size={28} />,
      title: t("Bakeries"),
      desc: t("Recipes & daily wastage"),
      link: "/industries/bakery",
    },
    {
      icon: <Smile size={28} />,
      title: t("Nuts & Crackers"),
      desc: t("Bulk, Weight and pack"),
      link: "/industries/salon",
    },
    {
      icon: <Truck size={28} />,
      title: t("Fruits & Vegetables"),
      desc: t("Fresh Stock, daily pricing"),
      link: "/industries/wholesale",
    },
  ];

  return (
    <section id="industries" className="bg-[#F4F7FF] mb-3">
      <div className="mx-auto px-5" style={{ maxWidth: "1180px" }}>

        {/* Section Head */}
        <div className="mx-auto mb-14 max-w-[700px] text-center">
         
          <h2 className="mb-3 text-[clamp(28px,3.6vw,44px)] font-black leading-[1.12] tracking-[-1.2px] text-gray-900">
            {t("Trusted across Egyptian retail")}
          </h2>
          <p className="text-[17px] leading-relaxed text-gray-500">
            {t("Whatever you sell, Hisabak fits with templates, taxes and workflows tuned for each industry.")}
          </p>
        </div>

        {/* Industry Grid */}
        <div className="grid grid-cols-2 gap-[14px] lg:grid-cols-4">
          {industries.map((industry, index) => (
            <a
              key={index}
              className="group cursor-pointer rounded-[20px] border-[1.5px] border-gray-200 bg-white px-4 py-6 text-center transition-all duration-300 hover:-translate-y-[3px] hover:border-[#1B4597] hover:shadow-[0_4px_24px_rgba(27,69,151,0.10)]"
              style={{ background: "#fff" }}
            >
              {/* Icon */}
              {/* Icon */}
              <div className="mx-auto mb-[10px] grid h-[52px] w-[52px] place-items-center rounded-[14px] text-gray-900 transition-transform duration-300 group-hover:scale-110">
                {industry.icon}
              </div>
              {/* Title */}
              <h4 className="mb-[3px] text-[14.5px] font-extrabold tracking-[-0.1px] text-gray-900">
                {industry.title}
              </h4>

              {/* Description */}
              <p className="text-[12px] leading-5 text-gray-400">
                {industry.desc}
              </p>
            </a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Industries;